import { SharedConstants } from "../../../../../shared/constants/shared.constants";
export class ViewApplicationDetailsPvConstants {
    static STEP_TITLE = "Details";
    static REFERENCE_NUMBER_LABEL = "Reference number";
    static REFERENCE_NUMBER_FORM_CONTROL_NAME = "referenceNumber";
    static DESCRIPTION_LABEL = "Description";
    static DESCRIPTION_FORM_CONTROL_NAME = "description";
    static VALUATIONBLOCK_SELECT_LABEL = "Select valuation block";
    static VALUATIONBLOCK_SELECT_FORM_CONTROL_NAME = "valuationBlockSelect";
    static APPLICATION_TYPE_SELECT_LABEL = "Application type";
    static APPLICATION_TYPE_SELECT_FORM_CONTROL_NAME = "applicationTypeSelect";
    static PROPERTY_TYPE_SELECT_LABEL = "Property type";
    static PROPERTY_TYPE_SELECT_FORM_CONTROL_NAME = "propertyTypeSelect";
    static SV_REASON_LABEL = "Reason for SV";
    static SV_REASON_FORM_CONTROL_NAME = "svReason";
    static PARENT_APPLICATION_SELECT_LABEL = "Parent application";
    static PARENT_APPLICATION_SELECT_FORM_CONTROL_NAME = "parentApplicationSelect";
    static DUPLICATE_METHOD_ERROR = "This method already exist.";
    // //TODO:: remove catagory and parent valuation block
    // static readonly CATEGORY_SELECT_LABEL = "Category";
    // static readonly CATEGORY_SELECT_FORM_CONTROL_NAME = "categorySelect";
    static VALUATION_BLOCK_DETAILS_FORM_CONTROL_NAME = "Valuation block details";
    static SAVE_BUTTON_PLACEHOLDER = SharedConstants.SAVE_LABEL;
    static VALIDATION_MESSAGES = {
        description: {
            required: `Description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        applicationType: {
            required: `Application type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        zone: {
            required: `Zone ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        parentApplication: {
            required: `Parent application ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        property: {
            required: `Property ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        svReason: {
            required: `Reason for supplementary valuation ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }
    };
}
